function ProductsFilter(inputElements, productElements, options){
	this.inputElements = Array.prototype.slice.call(inputElements);
	this.productElements = Array.prototype.slice.call(productElements);

	// default options
	this.options = {
		'filterInputType': 'default',
		'history' : false
	};

	// voeg input opties samen met default opties
	for (let attrname in options) { this.options[attrname] = options[attrname]; }

	// validate required inputs
	if(!(Array.isArray(this.inputElements) || this.inputElements.length > 0) || !(Array.isArray(this.productElements) || this.productElements.length > 0)){
		console.error('Something went wrong when building the page.');
		return;
	}

	// binds
	this.updateFilters = this.updateFilters.bind(this);
	this.isAllUnchecked = this.isAllUnchecked.bind(this);
	this.updateCheckBoardClasses = this.updateCheckBoardClasses.bind(this);

	// check for widget
	if(this.productElements.length > 0){
		this.containsWidget = (productElements[0].parentNode.getElementsByClassName('product-type-widget').length > 0)? true : false;
	}

	this.gridSupport = ('CSS' in window && CSS.supports('display', ' grid'));
	
	for(let i=0;i<this.inputElements.length;i++){
		this.inputElements[i].addEventListener('change', this.updateFilters);
	}

	this.updateCheckBoardClasses();

	window.addEventListener('resize', this.updateCheckBoardClasses);
}

ProductsFilter.prototype.updateFilters = function(){
	const allUnchecked = this.isAllUnchecked();

	let classCounter = 0;
	for(var i=0;i<this.inputElements.length;i++){
		for(var j=0;j<this.productElements.length;j++){
			if(this.productElements[j].getAttribute('data-kind') == this.inputElements[i].getAttribute('name')){
				if(this.inputElements[i].checked || allUnchecked){
					this.productElements[j].classList.remove('is-hidden');
				}
				else {
					this.productElements[j].classList.add('is-hidden');
				}
			}
		}
	}

	for(let i=0;i<this.productElements.length;i++){
		this.productElements[i].classList.add('is-loading');
		setTimeout(function(){
			this.classList.remove('is-loading');
		}.bind(this.productElements[i]), 400);
	}

	this.updateCheckBoardClasses();
};

ProductsFilter.prototype.isAllUnchecked = function(){
	let allUnchecked = true;

	for(var i=0;i<this.inputElements.length;i++){
		if(this.inputElements[i].checked){
			allUnchecked = false;
			break;
		}
	}

	return allUnchecked;
};

ProductsFilter.prototype.updateCheckBoardClasses = function(){
	if(this.productElements.length < 1){
		return;
	}
	
	// first items per row

	let lastVisibleItem = 0;

	for(let i=0;i<this.productElements.length;i++){
		if(!this.productElements[i].classList.contains('is-hidden')){
			this.productElements[i].classList.remove('is-odd');
			lastVisibleItem = this.productElements[i];
		}
	}

	const itemsPerRow = Math.round(lastVisibleItem.parentNode.offsetWidth / lastVisibleItem.offsetWidth);
	const itemsPerRowIsEven = (itemsPerRow % 2) ? false : true;

	let visibleCounter = 0;
	let visibleRowOffsetCounter = 0;
	let rowIsEven = false;

	for(let i=0;i<this.productElements.length;i++){
		if(this.productElements[i].classList.contains('is-hidden')){
			continue;
		}
		
		// set counter for visible items only
		visibleCounter ++;
		
		let rowCounter = Math.ceil(visibleCounter / itemsPerRow);

		let dummyAdded = false;

		if(this.containsWidget && this.gridSupport && itemsPerRow > 2 && visibleCounter == itemsPerRow - 1 || this.containsWidget && this.gridSupport && itemsPerRow < 3 && visibleCounter == itemsPerRow * 2 - 1) {
			// add dummy item
			visibleCounter ++;
			if(visibleCounter - 1 !== itemsPerRow * (rowCounter - 1) + 1){
				continue;
			}
			// exception for not using the offsetCounter
			dummyAdded = true;
		}

		if(!dummyAdded){
			// duplicate counter for when even items per row
			visibleRowOffsetCounter = visibleCounter;
		}
		
		if(rowCounter % 2){
			rowIsEven = true;
		}
		else {
			rowIsEven = false;
		}

		// when the items per row is even and the row is even then add 1 to the offsetcounter
		if(rowIsEven && itemsPerRowIsEven){
			visibleRowOffsetCounter ++;
		}

		if(visibleRowOffsetCounter % 2){
			this.productElements[i].classList.add('is-odd');
		}
	}
};

export default ProductsFilter;